import { ValueOf } from '@/types/util';

export const accountLockStatus = {
  AVAILABLE: 'ロックなし',
  LOCKED: 'ログインロック中',
  LOCKED_NO_LOGIN: '未ログインロック中',
} as const;

export type AccountLockStatusKey = keyof typeof accountLockStatus;
export type AccountLockStatusValue = ValueOf<typeof accountLockStatus>;

export const accountLockStatusKeys = Object.keys(accountLockStatus) as AccountLockStatusKey[];

/** v-select用items */
export const accountLockStatusItems = accountLockStatusKeys
  .map((key) => ({
    title: accountLockStatus[key],
    value: key,
  }));
